<template>
  <div>
    <transition name="fade_fast">
      <div id="app" v-if="!$root.is_loading">
        <template v-if="view === 'home'">
          <header>
            <Bandeau @openAbout="view = 'about'" />
          </header>
          <main class>
            <section class="m_parcours">
              <header
                class="m_parcours--entete"
                v-if="$root.copy_content.parcours"
              >
                <div
                  v-html="
                    `<span class='_excerpt'>PARCOURS —</span
            >${$root.copy_content.parcours}`
                  "
                />
              </header>
              <div
                class="m_parcours--taglist"
                v-if="Object.keys(taglist).length > 0"
              >
                <p>Filtrer par mots-clés&nbsp;:</p>

                <button
                  type="button"
                  class="m_parcours--taglist--tag"
                  :class="{ 'is--active': tag === keyword_filter }"
                  v-for="(count, tag) in taglist"
                  :key="tag"
                  @click="toggleFilter(tag)"
                >
                  {{ tag }}
                  <span class="m_parcours--taglist--tag--count">
                    <small>{{ count }}</small>
                  </span>
                </button>
              </div>

              <div class="m_parcours--buttons">
                <a
                  href="https://dodoc.tierslieuxedu.org/_publications/reply/test-gabarit-tle-v2"
                  target="_blank"
                >
                  Proposer un matériel
                </a>
                <a href="https://forum.tierslieuxedu.org/" target="_blank">
                  Participer au forum
                </a>
              </div>

              <div class="m_parcours--publications">
                <transition-group name="list-complete">
                  <Publication
                    v-for="(publication, index) in sorted_recipes"
                    :key="index"
                    :publication="publication"
                  />
                </transition-group>
              </div>
            </section>
          </main>
          <PublicationModal
            v-if="$root.current_publication_opened"
            :publication="$root.current_publication_opened"
            @close="$root.state.modal.current_publication_slug = false"
          />
        </template>
        <template v-else-if="view === 'about'">
          <About @close="view = 'home'" />
        </template>
        <footer class="m_footer">
          <span v-html="$root.copy_content.footer" />
        </footer>
      </div>
    </transition>
    <transition name="fadeslide">
      <div class="_loader" v-if="$root.is_loading">
        <span class="loader loader-quart"></span>
        Chargement…
      </div>
    </transition>
  </div>
</template>

<script>
import Bandeau from "./components/Bandeau.vue";
import Publication from "./components/Publication.vue";
import About from "./components/About.vue";
import PublicationModal from "./components/PublicationModal.vue";

export default {
  name: "app",
  components: {
    Bandeau,
    Publication,
    About,
    PublicationModal,
  },
  data() {
    return {
      keyword_filter: false,
      view: "home",
      // view: "about",
    };
  },
  mounted() {},
  computed: {
    filtered_recipes() {
      return this.$root.recipes_of_this_template.filter(
        (r) => r.follows_model === "test-gabarit-tle-v2"
      );
    },
    sorted_recipes() {
      return this.filtered_recipes.filter(
        (r) =>
          !this.keyword_filter ||
          (this.keyword_filter &&
            r.keywords &&
            r.keywords.some((k) => k.title === this.keyword_filter))
      );
    },
    taglist() {
      return this.filtered_recipes.reduce((acc, r) => {
        if (!Array.isArray(r.keywords) || r.keywords.length === 0) return acc;

        r.keywords.map((k) => {
          !acc.hasOwnProperty(k.title)
            ? (acc[k.title] = 1)
            : (acc[k.title] += 1);
        });

        return acc;
      }, {});
    },
  },
  methods: {
    toggleFilter(tag) {
      if (this.keyword_filter === tag) this.keyword_filter = false;
      else this.keyword_filter = tag;
    },
  },
};
</script>

<style lang="scss">
:root {
  --background-color: #fff;
  --logo-blue: var(--color-green);
  --logo-blue_lighter: hsl(174, 50%, 75%);
  --logo-blue_lighterer: hsl(174, 50%, 85%);
  --logo-blue_darker: #2a878f;
  --logo-red: #e4000a;
  --logo-red: #fc4b60;
  --color-blue: hsl(227, 73%, 41%);
  --color-blue-darker: hsl(227, 73%, 21%);
  --color-green: hsl(174, 50%, 55%);
  --color-yellow: rgb(253, 239, 0);
  --color-gray: #f2f2f2;
  --color-black: #333;
  --spacing: 1rem;
}
html {
  scroll-behavior: smooth;
}

body {
  font-family: "Fira Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  background-color: var(--background-color);
  color: var(--text-color);
  margin: 0;

  font-size: 1.1rem;
  line-height: 1.4;
}

#app {
  margin-top: calc(var(--spacing) * 3);
  padding: 0 var(--spacing);
}

.spaced {
  margin: 0 var(--spacing);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

hr {
  width: 2em;
  margin-left: 0;
  border: none;
  border-top: 1px solid #ccc;
}

button,
.button,
label,
.label {
  font-family: inherit;
  padding: 4px 6px;
  border-radius: 2px;
  font-weight: 400;
  font-size: 0.8em;
  cursor: pointer;

  color: white;
  background-color: var(--logo-blue);

  box-decoration-break: clone;

  transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1);

  svg {
    color: #fff;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &:hover,
  &:active,
  &:focus {
    background-color: var(--logo-blue_darker);
  }

  &.button-blue {
    background: var(--color-blue);

    &:hover,
    &:active,
    &:focus {
      background: var(--color-blue-darker) !important;
    }
  }
}

a {
  color: var(--logo-blue);

  &:hover,
  &:active,
  &:focus {
    color: var(--logo-blue_darker);
  }
}

label {
  appearance: none;
  color: var(--logo-blue);
  background-color: transparent;
}

button,
.button {
  appearance: none;
  border: 0;
  background-color: var(--color-green);
  color: white;
  border-radius: 4px;
  line-height: 1;
  padding: calc(var(--spacing) / 2);
  display: inline-flex;
  text-decoration: none;

  &:hover,
  &.is--active,
  &:focus {
    &:not([disabled]) {
      background-color: var(--logo-blue_lighter);
      outline: 0;
    }
  }
}

.bordered {
  border: 1px solid var(--logo-blue);

  &.bordered_white {
    border-color: white;
  }
}

.m_footer {
  max-width: 600px;
  margin: calc(var(--spacing) * 6) auto 0;
  text-align: center;
  font-size: 80%;
}

main {
  max-width: 1200px;
  // padding: 0 var(--spacing);
  width: 100%;
  margin: 0 auto;

  @media screen and (max-width: 50rem) {
    padding: 0;
  }
}

p {
  font-family: "Alegreya", Georgia, serif;
}

.m_parcours {
  // max-width: 1200px;
  width: 100%;
  // padding: 0 1em;
  margin: 0 auto;

  .m_parcours--entete {
    // border-top: 2px solid var(--logo-red);
    // border-bottom: 2px solid var(--logo-red);

    margin: var(--spacing) 0 var(--spacing);
    padding: var(--spacing) 0;

    > * {
      // display: inline-block;
    }

    p {
      margin: 0;
    }

    ._excerpt {
      color: var(--logo-red);
      font-family: "Fira Sans";
      font-weight: 500;
      margin-right: 0.5em;

      + p {
        display: inline;
      }
    }
  }

  .m_parcours--taglist {
    text-align: center;
    max-width: 500px;
    margin: 0 auto;
    border-bottom: 2px solid var(--logo-blue);
    padding-bottom: calc(var(--spacing) * 0.5);
    margin-bottom: calc(var(--spacing) * 2);

    > * {
      display: inline-block;
    }

    .m_parcours--taglist--tag {
      margin: 0 calc(var(--spacing) / 2) calc(var(--spacing) / 2)
        calc(var(--spacing) / 2);

      .m_parcours--taglist--tag--count {
        background-color: var(--logo-blue_lighter);
        border-radius: 50%;
        width: 1em;
        height: 1em;
        display: inline-block;
      }
    }
  }

  .m_parcours--buttons {
    text-align: center;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    margin: calc(var(--spacing) * 2);

    a {
      flex: 0 0 auto;
      display: block;
      background-color: var(--color-green);
      color: white;
      text-decoration: none;
      margin: calc(var(--spacing) / 2);
      padding: calc(var(--spacing) / 2) var(--spacing);
      border-radius: 2em;
      // font-weight: 500;
      text-transform: lowercase;
      font-variant: small-caps;
      line-height: 1;

      &:hover,
      &:focus {
        background-color: var(--logo-blue_darker);
      }
    }
  }

  .m_parcours--publications {
    > span {
      position: relative;
      display: grid;
      grid-gap: var(--spacing);
      grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));

      @media screen and (max-width: 50rem) {
        display: block;
      }

      > * {
        position: relative;
      }
    }
  }
}

.mainText {
  margin-bottom: var(--spacing);

  p {
    margin: 0;
  }
  .ql-align-center {
    text-align: center;
  }

  a {
    color: var(--logo-blue) !important;

    &:hover,
    &:active,
    &:focus {
      color: var(--logo-blue_darker) !important;
    }
  }
  h1 {
    position: sticky;
    top: 0;
    margin: 0;
    padding-top: calc(var(--spacing) * 1);
  }
}

._loader {
  position: fixed;
  width: 100%;
  height: 100%;
  color: #333;

  font-size: 100%;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;

  --spinner-size: 20px;
  --spinner-border: 2px;

  // font-family: "Roboto Mono";
  text-transform: uppercase;
  font-weight: 300;
  padding-bottom: 2em;
}

.loader {
  position: relative;
  display: inline-block;
  width: var(--spinner-size);
  height: var(--spinner-size);
  vertical-align: middle;

  margin-right: 0.5em;
}

/*	$Loader Quadrant
	========================================================================== */

.loader-quart {
  border-radius: var(--spinner-size);
  border: var(--spinner-border) dotted rgba(51, 51, 51, 0.2);
}

.loader-quart:after {
  content: "";
  position: absolute;
  top: calc(-1 * var(--spinner-border));
  left: calc(-1 * var(--spinner-border));
  bottom: calc(-1 * var(--spinner-border));
  right: calc(-1 * var(--spinner-border));
  border-radius: var(--spinner-size);
  border: var(--spinner-border) solid transparent;
  border-top-color: #333;
  -webkit-animation: spin 1s linear infinite;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.svg-icon {
  width: 2em;
  height: 2em;
}

.titre {
  text-align: center;
  margin-top: 0;
  margin-bottom: calc(var(--spacing) * 2);

  ::v-deep h1 {
    font-size: 2rem;
    font-weight: 900;
    text-transform: uppercase;
  }

  ::v-deep h2 {
    font-weight: 300;
    font-size: 1.4rem;
  }

  ::v-deep {
    h1 + h2 {
      margin-top: -1em;
    }
  }
}

.svg-icon path,
.svg-icon polygon,
.svg-icon rect {
  fill: currentColor;
}

.svg-icon circle,
.svg-icon line {
  stroke: currentColor;
  stroke-width: 2;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s cubic-bezier(0.19, 1, 0.22, 1);
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fadeslide-enter-active,
.fadeslide-leave-active {
  transition: all 1s cubic-bezier(0.19, 1, 0.22, 1) !important;
}
.fadeslide-enter,
.fadeslide-leave-to {
  opacity: 0;
  transform: translateY(15px);
}
.fadeslide-leave-to {
  pointer-events: none;
}

.fade_fast-enter-active,
.fade_fast-leave-active {
  opacity: 1;
  transition: opacity 0.15s linear;
}
.fade_fast-enter,
.fade_fast-leave-to {
  opacity: 0;
  transition: opacity 0.15s linear;
}

.list-complete-move {
  position: relative;
  transition: all 0.6s cubic-bezier(0.19, 1, 0.22, 1) !important;
}
.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
}
.list-complete-leave-active {
  position: absolute;
  z-index: 0 !important;
}

.ListView-enter-active,
.ListView-leave-active {
  opacity: 1;
  transform: scale(1);
  transform-origin: center center;
  transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1) !important;
}
.ListView-enter,
.ListView-leave-to {
  opacity: 0;
  transform: scale(0.96);
}
</style>
